import { useState } from "react";
import { useLocation } from "react-router-dom";

import ButtonDefault from "../../components/form/ButtonDefault";
import InputDefault from "../../components/form/InputDefault";
import { IconClosedEye, IconEyeOpen } from "../../components/icons";
import logoLegalOps from "../../assets/images/logoSmalRed.svg";
import logoClaude from "../../assets/images/logoClaude.svg";

import {
    Card,
    Container,
    DenyButton,
    ErrorMessage,
    FormWrapper,
    IconsRow,
    Subtitle,
    Title,
} from "./styles";

export default function McpLogin() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);

    const clientId = params.get('client_id') ?? '';
    const redirectUri = params.get('redirect_uri') ?? '';
    const state = params.get('state') ?? '';
    const codeChallenge = params.get('code_challenge') ?? '';
    const codeChallengeMethod = params.get('code_challenge_method') ?? '';

    const [email, setEmail] = useState('');
    const [senha, setSenha] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [emptyField, setEmptyField] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    if (!redirectUri) {
        return (
            <Container>
                <Card>
                    <Title>Requisição inválida</Title>
                    <ErrorMessage>O parâmetro <strong>redirect_uri</strong> é obrigatório.</ErrorMessage>
                    <DenyButton onClick={() => { setErrorMessage('Autorização recusada.'); }}>
                        Recusar
                    </DenyButton>
                    {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
                </Card>
            </Container>
        );
    }

    async function handleSubmit(e: React.FormEvent) {
        e.preventDefault();

        if (!email || !senha) {
            setEmptyField(true);
            setErrorMessage('Campo obrigatório');
            return;
        }

        setLoading(true);
        setErrorMessage('');

        try {
            const mcpApiUrl = (process.env.REACT_APP_MCP_API_URL || '').replace(/\/$/, '');
            const response = await fetch(`${mcpApiUrl}/authorize`, {
                method: 'POST',
                redirect: 'manual',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    email,
                    senha,
                    client_id: clientId,
                    redirect_uri: redirectUri,
                    state,
                    code_challenge: codeChallenge,
                    code_challenge_method: codeChallengeMethod,
                }),
            });

            if (response.ok) {
                const data = await response.json();
                if (data.redirect_url) {
                    window.location.href = data.redirect_url;
                }
            } else if (response.status === 401) {
                setErrorMessage('E-mail ou senha incorretos.');
            }
        } catch {
            setErrorMessage('Erro ao processar a requisição. Tente novamente.');
        } finally {
            setLoading(false);
        }
    }

    function handleDeny() {
        window.location.href = `${redirectUri}?error=access_denied`;
    }

    return (
        <Container>
            <Card>
                <IconsRow>
                    <img src={logoClaude} alt="Claude" style={{height: '45px', width: 'auto', maxWidth: 'none'} as React.CSSProperties} />
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 12H20M4 12L8 8M4 12L8 16M20 12L16 8M20 12L16 16" stroke="#888" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <img src={logoLegalOps} alt="EasyJur Legal Ops" style={{height: '40px', width: 'auto', maxWidth: 'none'} as React.CSSProperties} />
                </IconsRow>

                <Title>Entre no EasyJur Legal Ops</Title>

                <Subtitle>
                    Para autorizar a integração do <span className="highlight">Claude</span> com
                    seu Legal Ops, faça login na sua conta.
                </Subtitle>

                <form onSubmit={handleSubmit}>
                    <FormWrapper>
                        <InputDefault
                            title="E-MAIL"
                            placeholder="voce@empresa.com"
                            value={email}
                            onChangeText={setEmail}
                            error={emptyField && !email ? errorMessage : ''}
                        />

                        <div style={{ position: 'relative' }}>
                            <InputDefault
                                title="SENHA"
                                type={showPassword ? 'text' : 'password'}
                                value={senha}
                                onChangeText={setSenha}
                                error={emptyField && !senha ? errorMessage : (!email && errorMessage === 'E-mail ou senha incorretos.' ? errorMessage : (email && errorMessage === 'E-mail ou senha incorretos.' ? errorMessage : ''))}
                            />
                            <div
                                style={{ position: 'absolute', top: '40%', right: '5%', cursor: 'pointer' }}
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <IconClosedEye /> : <IconEyeOpen />}
                            </div>
                        </div>

                        {errorMessage && errorMessage !== 'Campo obrigatório' && (
                            <ErrorMessage>{errorMessage}</ErrorMessage>
                        )}

                        <ButtonDefault loading={loading}>Continuar</ButtonDefault>

                        <DenyButton type="button" onClick={handleDeny}>
                            Recusar
                        </DenyButton>
                    </FormWrapper>
                </form>
            </Card>
        </Container>
    );
}
